
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.667 10c0-.72.091-1.42.263-2.086a2.5 2.5 0 002.23-3.858 8.325 8.325 0 013.612-2.088 2.5 2.5 0 004.456 0 8.324 8.324 0 013.613 2.088 2.5 2.5 0 002.23 3.858c.171.666.262 1.365.262 2.086 0 .72-.091 1.42-.263 2.086a2.5 2.5 0 00-2.23 3.858 8.324 8.324 0 01-3.612 2.088 2.5 2.5 0 00-4.456 0 8.325 8.325 0 01-3.613-2.088 2.5 2.5 0 00-2.229-3.858A8.349 8.349 0 011.667 10zm4.003 2.5c.525.91.676 1.955.47 2.936.34.242.702.452 1.08.626A4.161 4.161 0 0110 15c1.05 0 2.032.393 2.78 1.062.378-.174.74-.384 1.08-.626a4.161 4.161 0 01.47-2.936 4.16 4.16 0 012.308-1.876 6.778 6.778 0 000-1.249A4.16 4.16 0 0114.33 7.5a4.161 4.161 0 01-.47-2.937 6.66 6.66 0 00-1.08-.625A4.16 4.16 0 0110 5a4.161 4.161 0 01-2.78-1.062c-.378.174-.74.384-1.08.625A4.16 4.16 0 015.67 7.5a4.16 4.16 0 01-2.308 1.875 6.774 6.774 0 000 1.25A4.161 4.161 0 015.67 12.5zm4.33 0a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm0-1.667a.833.833 0 100-1.666.833.833 0 000 1.666z","fill":"#50535A"}})])
          )
        }
      }
    